import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

export default function PriceButton({
  text,
  price,
  oldPrice,
  variant,
  ...props
}) {
  return (
    <Button
      disableElevation
      fullWidth
      variant={variant}
      color="primary"
      size="large"
      sx={{ minHeight: 64 }}
      {...props}
    >
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="center"
        wrap="nowrap"
      >
        {text && (
          <Grid item>
            <Box sx={{ fontWeight: 700 }}>{text}</Box>
          </Grid>
        )}
        <Grid item>
          <Box sx={{ fontSize: "1.6rem", fontWeight: 800, lineHeight: 1.2 }}>
            {price}
          </Box>

          {oldPrice && (
            <Box
              sx={{
                opacity: 0.7,
                lineHeight: 1,
                textDecoration: "line-through",
              }}
            >
              {oldPrice}
            </Box>
          )}
        </Grid>
      </Grid>
    </Button>
  );
}

PriceButton.defaultProps = {
  variant: "contained",
};

PriceButton.propTypes = {
  variant: PropTypes.oneOf(["contained", "outlined-product"]),
  text: PropTypes.string,
  oldPrice: PropTypes.string,
  price: PropTypes.string,
};
